<template lang="pug">
  div.container
      app-divider(label="Ato legal da criação")
      el-row(:gutter="20")
        el-col.inputDiv(:span="12")
          app-label(label="Tipo de Documento Legal", :required="true")
          el-select.full-width(v-model="informacoesAtosLegais.tipoDocumentoLegal" placeholder="Selecione o tipo de documento legal")
            el-option(
              v-for="item in optionsTipoDocumentoLegal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
        el-col.inputDiv(:span="12")
          app-label(label="Instrumento da Publicação", :required="true")
          el-radio-group(v-model="informacoesAtosLegais.instrumentoPublicacao", class="radio-group-horizontal")
            el-radio(:label="'DiarioOficialUniao'") Diário Oficial da União
            el-radio(:label="'DiarioOficialEstado'") Diário Oficial do Estado
            el-radio(:label="'DiarioOficialMunicipio'") Diário Oficial do Município
      el-row(:gutter="20")
        el-col.inputDiv(:span="4", v-if="informacoesAtosLegais.instrumentoPublicacao === 'DiarioOficialEstado' || informacoesAtosLegais.instrumentoPublicacao === 'DiarioOficialMunicipio'")
          app-label(label="UF", :required="true")
          el-select.full-width-select(v-model="informacoesAtosLegais.uf" placeholder="Selecione a UF" @change="changeEstado")
            el-option(
              v-for="estado in estadosBr"
              :key="estado.codigo"
              :label="estado.nome"
              :value="estado.codigo"
            )
        el-col.inputDiv(:span="4" v-if="informacoesAtosLegais.municipio && informacoesAtosLegais.municipio !== '' && (informacoesAtosLegais.instrumentoPublicacao === 'DiarioOficialEstado' || informacoesAtosLegais.instrumentoPublicacao === 'DiarioOficialMunicipio')")
          app-label(label="Município", :required="true")
          el-select.full-width-select(v-model="informacoesAtosLegais.municipio.id" placeholder="Selecione o município")
            el-option(v-for="item in municipios" :key="item.id" :label="item.nome" :value="item.id")
        el-col.inputDiv(:span="8")
          app-label(label="Número do Documento", :required="true")
          el-input.input(
            v-model="informacoesAtosLegais.numeroDocumento"
            type="text"
            placeholder="Digite o número do documento"
          )
        el-col.inputDiv(:span="8")
          app-label(label="Data do Documento", :required="true")
          el-date-picker.full-width-documento(
            v-model="informacoesAtosLegais.dataDocumento"
            type="date"
            placeholder="Selecione a data do documento"
            format="dd/MM/yyyy"
            v-mask="'##/##/#####'"
          )
        el-col.inputDiv(:span="8")
          app-label(label="Data da Publicação", :required="true")
          el-date-picker.full-width(
            v-model="informacoesAtosLegais.dataPublicacao"
            type="date"
            placeholder="Selecione a data da publicação"
            format="dd/MM/yyyy"
            v-mask="'##/##/#####'"
          )
        el-col.inputDiv(:span="8")
          app-label(label="Área em Hectares", :required="true")
          el-input.input(
            v-model="informacoesAtosLegais.areaHectares"
            type="text"
            placeholder="Digite a área em hectares"
          )
        el-col.inputDiv(:span="8")
          app-label(label="Link para Ato Legal", :required="true")
          el-input.input(
            v-model="informacoesAtosLegais.linkAtoLegal"
            type="text"
            placeholder="Digite o link para o ato legal"
          )
      el-row(:gutter="30").margin.mb-20
        el-col.inputDiv(:span="24")
          app-label(label="Anexo do Ato Legal", :required="true")
          app-upload-area(
          id="documento"
          :target="'publico/upload'"
          :fileType="validExtensions"
          :onSuccess="onSuccessAnexoAtoLegal"
          :hasDownloadButton="false"
          v-model="informacoesAtosLegais.anexoAtoLegal"
          @removerDocumento="removerAnexoAtoLegal"
          :documento="informacoesAtosLegais.anexoAtoLegal"
          )
      el-row(:gutter="20").margin.mb-20
        el-col.inputDiv(:span="12")
          app-label(label="Existe outro ato legal que altera ou complementa?",  :required="true")
          el-radio-group(v-model="informacoesAtosLegais.existeAtoLegalOuComplementar")
            el-radio(:label="'sim'") Sim
            el-radio(:label="'nao'") Não
      app-divider(label="Plano de manejo")
      el-row(:gutter="20").margin.mb-20
        el-col.inputDiv(:span="12")
          app-label(label="Há plano de manejo aprovado?",  :required="true")
          el-radio-group(v-model="informacoesAtosLegais.planoManejoAprovado")
            el-radio(:label="'sim'") Sim
            el-radio(:label="'nao'") Não
      el-row(v-if="informacoesAtosLegais.planoManejoAprovado === 'sim'", :gutter="20").margin.mb-20
        el-col.inputDiv(:span="12")
          app-label(label="Tipo de Documento Legal", :required="true")
          el-select.full-width(v-model="informacoesAtosLegais.planoManejoTipoDocumento" placeholder="Selecione o tipo de documento legal")
            el-option(
              v-for="item in optionsTipoDocumentoLegal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
        el-col.inputDiv(:span="12")
          app-label(label="Instrumento da Publicação", :required="true")
          el-radio-group(v-model="informacoesAtosLegais.instrumentoPublicacaoPlanoManejo")
            el-radio(:label="'DiarioOficialUniao'") Diário Oficial da União
            el-radio(:label="'DiarioOficialEstado'") Diário Oficial do Estado
            el-radio(:label="'DiarioOficialMunicipio'") Diário Oficial do Município
      el-row(v-if="informacoesAtosLegais.planoManejoAprovado === 'sim'", :gutter="20").margin.mb-20
        el-col.inputDiv(:span="4", v-if="informacoesAtosLegais.instrumentoPublicacaoPlanoManejo === 'DiarioOficialEstado' || informacoesAtosLegais.instrumentoPublicacaoPlanoManejo === 'DiarioOficialMunicipio'")
          app-label(label="UF", :required="true")
          el-select.full-width(v-model="informacoesAtosLegais.ufPlanoManejo" placeholder="Selecione a UF" @change="changeEstadoPlanoManejo")
            el-option(
              v-for="estado in estadosBr"
              :key="estado.codigo"
              :label="estado.nome"
              :value="estado.codigo"
            )
        el-col.inputDiv(:span="4" v-if="informacoesAtosLegais.municipioPlanoManejo && informacoesAtosLegais.municipioPlanoManejo !== '' && (informacoesAtosLegais.instrumentoPublicacaoPlanoManejo === 'DiarioOficialEstado' || informacoesAtosLegais.instrumentoPublicacaoPlanoManejo === 'DiarioOficialMunicipio')")
          app-label(label="Município", :required="true")
          el-select.full-width-select(v-model="informacoesAtosLegais.municipioPlanoManejo.id" placeholder="Selecione o município")
            el-option(v-for="item in municipiosPlanoManejo" :key="item.id" :label="item.nome" :value="item.id")
        el-col.inputDiv(:span="8")
          app-label(label="Número do Documento", :required="true")
          el-input.input(
            v-model="informacoesAtosLegais.numeroDocumentoPlano"
            type="text"
            placeholder="Digite o número do documento do plano"
          )
        el-col.inputDiv(:span="8")
          app-label(label="Data do Documento", :required="true")
          el-date-picker.full-width-documento(
            v-model="informacoesAtosLegais.dataDocumentoPlano"
            type="date"
            placeholder="Selecione a data do documento do plano"
            format="dd/MM/yyyy"
            v-mask="'##/##/#####'"
          )
        el-col.inputDiv(:span="8")
          app-label(label="Data da publicação", :required="true")
          el-date-picker.full-width(
            v-model="informacoesAtosLegais.dataPublicacaoPlano"
            type="date"
            placeholder="Selecione a data da publicação"
            format="dd/MM/yyyy"
            v-mask="'##/##/#####'"
          )
        el-col.inputDiv(:span="8")
          app-label(label="Link para documento ato legal", :required="true")
          el-input.input(
            v-model="informacoesAtosLegais.linkPlanoManejoAtoLegal"
            type="text"
            placeholder="Digite o link para ato legal"
          )
        el-col.inputDiv(:span="8")
          app-label(label="Link para documento do Plano de Manejo", :required="true")
          el-input.input(
            v-model="informacoesAtosLegais.linkPlanoManejo"
            type="text"
            placeholder="Digite o link para o plano de manejo"
          )
      el-row(v-if="informacoesAtosLegais.planoManejoAprovado === 'sim'", :gutter="30").margin.mb-20
        el-col.inputDiv(:span="24")
          app-label(label="Anexo do ato legal")
          app-upload-area(
            id="documentoPlanoManejoAtoLegal"
            :target="'publico/upload'"
            :fileType="validExtensions"
            :onSuccess="onSuccessAnexoPlanoManejoAtoLegal"
            :hasDownloadButton="false",
            v-model="informacoesAtosLegais.anexoPlanoManejoAtoLegal"
            :documento="informacoesAtosLegais.anexoPlanoManejoAtoLegal"
            @removerDocumento="removerAnexoPlanoManejo"
          )
      el-row(v-if="informacoesAtosLegais.planoManejoAprovado === 'sim'", :gutter="30").margin.mb-20
        el-col.inputDiv(:span="24")
          app-label(label="Anexo pdf do documento plano manejo", :required="true")
          app-upload-area(
            id="documentoPlanoManejo"
            :target="'publico/upload'"
            :fileType="validExtensions"
            :onSuccess="onSuccessAnexoPlanoManejo"
            :hasDownloadButton="false",
            v-model="informacoesAtosLegais.anexoPlanoManejo"
            :documento="informacoesAtosLegais.anexoPlanoManejo"
            @removerDocumento="removerAnexoPlanoManejo"
          )
      app-divider(label="Documento Conselho")
      el-row(:gutter="20").margin.mb-20
        el-col.inputDiv(:span="12")
          app-label(label="Deseja adicionar documento do conselho?", :required="true")
          el-radio-group(v-model="informacoesAtosLegais.documentoConselho")
            el-radio(:label="'sim'") Sim
            el-radio(:label="'nao'") Não
      el-row(v-if="informacoesAtosLegais.documentoConselho === 'sim'", :gutter="20").margin.mb-20
        el-col.inputDiv(:span="12")
          app-label(label="Tipo de Documento Conselho")
          el-select.full-width(v-model="informacoesAtosLegais.tipoDocumentoLegalConselho" placeholder="Selecione o tipo de documento legal")
            el-option(
              v-for="item in optionsTipoDocumentoLegal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
        el-col.inputDiv(:span="12")
          app-label(label="Instrumento da Publicação", :required="true")
          el-radio-group(v-model="informacoesAtosLegais.instrumentoPublicacaoConselho")
            el-radio(:label="'DiarioOficialUniao'") Diário Oficial da União
            el-radio(:label="'DiarioOficialEstado'") Diário Oficial do Estado
            el-radio(:label="'DiarioOficialMunicipio'") Diário Oficial do Município
      el-row(v-if="informacoesAtosLegais.documentoConselho === 'sim'", :gutter="20").margin.mb-20
        el-col.inputDiv(:span="6", v-if="informacoesAtosLegais.instrumentoPublicacaoConselho === 'DiarioOficialEstado' ||  informacoesAtosLegais.instrumentoPublicacaoConselho === 'DiarioOficialMunicipio'")
          app-label(label="UF", :required="true")
          el-select.full-width(v-model="informacoesAtosLegais.ufConselho" placeholder="Selecione a UF" @change="changeEstadoConselho")
            el-option(
              v-for="estado in estadosBr"
              :key="estado.codigo"
              :label="estado.nome"
              :value="estado.codigo"
            )
        el-col.inputDiv(:span="6" v-if="informacoesAtosLegais.municipioConselho && informacoesAtosLegais.municipioConselho !== '' && (informacoesAtosLegais.instrumentoPublicacaoConselho === 'DiarioOficialEstado' ||  informacoesAtosLegais.instrumentoPublicacaoConselho === 'DiarioOficialMunicipio')")
          app-label(label="Município", :required="true")
          el-select.full-width-select(v-model="informacoesAtosLegais.municipioConselho.id" placeholder="Selecione o município")
            el-option(v-for="item in municipiosConselho" :key="item.id" :label="item.nome" :value="item.id")
        el-col.inputDiv(:span="6")
          app-label(label="Número do Documento", :required="true")
          el-input.input(
            v-model="informacoesAtosLegais.numeroDocumentoConselho"
            type="text"
            placeholder="Digite o número do documento do plano"
          )
        el-col.inputDiv(:span="6")
          app-label(label="Data do Documento", :required="true")
          el-date-picker.full-width-documento(
            v-model="informacoesAtosLegais.dataDocumentoConselho"
            type="date"
            placeholder="Selecione a data do documento do plano"
            format="dd/MM/yyyy"
            v-mask="'##/##/#####'"
          )
        el-col.inputDiv(:span="12")
          app-label(label="Data da publicação")
          el-date-picker.full-width(
            v-model="informacoesAtosLegais.dataPublicacaoConselho"
            type="date"
            placeholder="Selecione a data da publicação"
            format="dd/MM/yyyy"
            v-mask="'##/##/#####'"
          )
        el-col.inputDiv(:span="12")
          app-label(label="Link para ato legal", :required="true")
          el-input.input(
            v-model="informacoesAtosLegais.linkPlanoManejoConselho"
            type="text"
            placeholder="Digite o link para ato legal"
          )
      el-row(v-if="informacoesAtosLegais.documentoConselho === 'sim'", :gutter="30").margin.mb-20
        el-col.inputDiv(:span="24")
          app-label(label="Anexo do ato legal", :required="true")
          app-upload-area(
            id="documentoConselho"
            :target="'publico/upload'"
            :fileType="validExtensions"
            :onSuccess="onSuccessAnexoDocumentoConselho"
            :hasDownloadButton="false",
            v-model="informacoesAtosLegais.anexoDocumentoConselho"
            :documento="informacoesAtosLegais.anexoDocumentoConselho"
            @removerDocumento="removerAnexoDocumentoConselho"
          )
      app-divider(label="Gestão/Planejamento")
      el-row(:gutter="20").margin.mb-20
        el-col.inputDiv(:span="12")
          app-label(label="Deseja adicionar outros Instrumentos de Gestão/Planejamento?", :required="true")
          el-radio-group(v-model="informacoesAtosLegais.outrosInstrumentos")
            el-radio(:label="'sim'") Sim
            el-radio(:label="'nao'") Não
      el-row(v-if="informacoesAtosLegais.outrosInstrumentos === 'sim'", :gutter="20").margin.mb-20
        el-col.inputDiv(:span="12")
          app-label(label="Tipo de Documento Legal", :required="true")
          el-select.full-width(v-model="informacoesAtosLegais.outrosInstrumentosTipoDocumento" placeholder="Selecione o tipo de documento legal")
            el-option(
              v-for="item in optionsTipoDocumentoLegal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
        el-col.inputDiv(:span="12")
          app-label(label="Instrumento da Publicação", :required="true")
          el-radio-group(v-model="informacoesAtosLegais.gestaoInstrumentoPublicacao")
            el-radio(:label="'DiarioOficialUniao'") Diário Oficial da União
            el-radio(:label="'DiarioOficialEstado'") Diário Oficial do Estado
            el-radio(:label="'DiarioOficialMunicipio'") Diário Oficial do Município
      el-row(v-if="informacoesAtosLegais.outrosInstrumentos === 'sim'", :gutter="20").margin.mb-20
        el-col.inputDiv(:span="6", v-if="informacoesAtosLegais.gestaoInstrumentoPublicacao === 'DiarioOficialEstado' || informacoesAtosLegais.gestaoInstrumentoPublicacao === 'DiarioOficialMunicipio'")
          app-label(label="UF", :required="true")
          el-select.full-width(v-model="informacoesAtosLegais.ufGestao" placeholder="Selecione a UF" @change="changeEstadoGestao")
            el-option(
              v-for="estado in estadosBr"
              :key="estado.codigo"
              :label="estado.nome"
              :value="estado.codigo"
            )
        el-col.inputDiv(:span="6" v-if="informacoesAtosLegais.municipioGestao && informacoesAtosLegais.municipioGestao !== '' && (informacoesAtosLegais.gestaoInstrumentoPublicacao === 'DiarioOficialEstado' || informacoesAtosLegais.gestaoInstrumentoPublicacao === 'DiarioOficialMunicipio')")
          app-label(label="Município", :required="true")
          el-select.full-width-select(v-model="informacoesAtosLegais.municipioGestao.id" placeholder="Selecione o município")
            el-option(v-for="item in municipiosGestao" :key="item.id" :label="item.nome" :value="item.id")
        el-col.inputDiv(:span="6")
          app-label(label="Número do Documento", :required="true")
          el-input.input(
            v-model="informacoesAtosLegais.numeroDocumentoPlanoGestao"
            type="text"
            placeholder="Digite o número do documento"
          )
        el-col.inputDiv(:span="6")
          app-label(label="Data do Documento", :required="true")
          el-date-picker.full-width-documento(
            v-model="informacoesAtosLegais.dataDocumentoPlanoGestao"
            type="date"
            placeholder="Selecione a data do documento"
            format="dd/MM/yyyy"
            v-mask="'##/##/#####'"
          )
        el-col.inputDiv(:span="12")
          app-label(label="Data da Publicação", :required="true")
          el-date-picker.full-width(
            v-model="informacoesAtosLegais.dataPublicacaoGestao"
            type="date"
            placeholder="Selecione a data da publicação"
            format="dd/MM/yyyy"
            v-mask="'##/##/#####'"
          )
        el-col.inputDiv(:span="12")
          app-label(label="Link para ato legal", :required="true")
          el-input.input(
            v-model="informacoesAtosLegais.linkPlanoManejoGestaoAtoLegal"
            type="text"
            placeholder="Digite o link para ato legal"
          )
      el-row(v-if="informacoesAtosLegais.outrosInstrumentos === 'sim'", :gutter="30").margin.mb-20
        el-col.inputDiv(:span="24")
          app-label(label="Anexo do ato legal", :required="true")
          app-upload-area(
            id="documentoGestaoAtoLegal"
            :target="'publico/upload'"
            :fileType="validExtensions"
            :onSuccess="onSuccessInstrumentosGestaoAtoLegal"
            :hasDownloadButton="false",
            v-model="informacoesAtosLegais.anexoInstrumentoGestaoAtoLegal"
            :documento="informacoesAtosLegais.anexoInstrumentoGestaoAtoLegal"
            @removerDocumento="removerInstrumentoGestaoAtoLegal"
          )
      el-row(v-if="informacoesAtosLegais.outrosInstrumentos === 'sim'", :gutter="30").margin.mb-20
        el-col.inputDiv(:span="12")
          app-label(label="Tipo de Instrumento de Gestão/Planejamento", :required="true")
          el-select.full-width(v-model="informacoesAtosLegais.tipoDocumentoLegalGestao" placeholder="Selecione o tipo de documento legal")
            el-option(
              v-for="item in optionsTipoInstrumentoGestao"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
        el-col.inputDiv(:span="12")
          app-label(label="Link para o instrumento de gestão/planejamento", :required="true")
          el-input.input(
            v-model="informacoesAtosLegais.linkPlanoManejoGestao"
            type="text"
            placeholder="Digite o link para o instrumento de gestão/planejamento"
          )
      el-row(v-if="informacoesAtosLegais.outrosInstrumentos === 'sim'", :gutter="30").margin.mb-20
        el-col.inputDiv(:span="24")
          app-label(label="Anexo do instrumento de gestão/planejamento", :required="true")
          app-upload-area(
            id="documentoGestao"
            :target="'publico/upload'"
            :fileType="validExtensions"
            :onSuccess="onSuccessInstrumentosGestao"
            :hasDownloadButton="false",
            v-model="informacoesAtosLegais.anexoInstrumentoGestao"
            :documento="informacoesAtosLegais.anexoInstrumentoGestao"
            @removerDocumento="removerInstrumentoGestao"
          )
</template>
<script>
import estadosBr from '@/constants/estados'
import AppUploadArea from '@/components/AppUploadArea'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import { mapActions } from 'vuex'

export default {

  components: {
    AppUploadArea,
    AppLabel,
    AppDivider
  },
  props: {
    atos: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      documento: null,
      file: null,
      validExtensions: ['xlsx', 'xls', 'csv', 'pdf'],
      estadosBr,
      municipios: [],
      municipiosPlanoManejo: [],
      municipiosConselho: [],
      municipiosGestao: [],
      informacoesAtosLegais: {...this.atos},
      optionsTipoDocumentoLegal: [
        { label: 'Lei', value: 'lei' },
        { label: 'Decreto', value: 'decreto' },
        { label: 'Portaria', value: 'portaria' }
      ],
      optionsTipoInstrumentoGestao: [
        { label: 'Plano de uso público', value: 'planoUsoPublico' },
        { label: 'Plano de prevenção e proteção contra incêndios', value: 'protecaoIncendios' },
        { label: 'Projeto de educação ambiental', value: 'educacaoAmbiental' },
        { label: 'Plano de recuperação de áreas degradadas', value: 'recuperacaoAreas' }
      ]
    }
  },
  async mounted () {
    this.informacoesAtosLegais.municipio = this.informacoesAtosLegais?.municipio?.id ? this.informacoesAtosLegais.municipio : { id: null }
    if (this.informacoesAtosLegais.uf) {
      this.municipios = await this.getMunicipiosByUf(this.informacoesAtosLegais.uf)
    }
    this.informacoesAtosLegais.municipioPlanoManejo = this.informacoesAtosLegais?.municipioPlanoManejo?.id ? this.informacoesAtosLegais.municipioPlanoManejo : { id: null }
    if (this.informacoesAtosLegais.ufPlanoManejo) {
      this.municipiosPlanoManejo = await this.getMunicipiosByUf(this.informacoesAtosLegais.ufPlanoManejo)
    }
    this.informacoesAtosLegais.municipioConselho = this.informacoesAtosLegais?.municipioConselho?.id ? this.informacoesAtosLegais.municipioConselho : { id: null }
    if (this.informacoesAtosLegais.ufConselho) {
      this.municipiosConselho = await this.getMunicipiosByUf(this.informacoesAtosLegais.ufConselho)
    }
    this.informacoesAtosLegais.municipioGestao = this.informacoesAtosLegais?.municipioGestao?.id ? this.informacoesAtosLegais.municipioGestao : { id: null }
    if (this.informacoesAtosLegais.ufGestao) {
      this.municipiosGestao = await this.getMunicipiosByUf(this.informacoesAtosLegais.ufGestao)
    }
  },
  methods: {
    ...mapActions({
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),
    async changeEstado () {
      this.informacoesAtosLegais.municipio = {id: null}
      this.municipios = await this.getMunicipiosByUf(this.informacoesAtosLegais.uf)
    },
    async changeEstadoPlanoManejo () {
      this.informacoesAtosLegais.municipioPlanoManejo = {id: null}
      this.municipiosPlanoManejo = await this.getMunicipiosByUf(this.informacoesAtosLegais.ufPlanoManejo)
    },
    async changeEstadoConselho () {
      this.informacoesAtosLegais.municipioConselho = {id: null}
      this.municipiosConselho = await this.getMunicipiosByUf(this.informacoesAtosLegais.ufConselho)
    },
    async changeEstadoGestao () {
      this.informacoesAtosLegais.municipioGestao = {id: null}
      this.municipiosGestao = await this.getMunicipiosByUf(this.informacoesAtosLegais.ufGestao)
    },
    onSuccessAnexoAtoLegal (id, resumableFile, fileKey) {
      this.informacoesAtosLegais.anexoAtoLegal = {
        nome: resumableFile.fileName,
        tipo: {
          id: 67,
          codigo: 'ATOS_CONSTITUTIVOS'
        },
        key: fileKey
      }
      this.$emit('update:atos', { ...this.informacoesAtosLegais })
    },
    onSuccessAnexoPlanoManejo (id, resumableFile, fileKey) {
      this.informacoesAtosLegais.anexoPlanoManejo = {
        nome: resumableFile.fileName,
        tipo: {
          id: 67,
          codigo: 'ATOS_CONSTITUTIVOS'
        },
        key: fileKey
      }
      this.$emit('update:atos', { ...this.informacoesAtosLegais })
    },
    onSuccessAnexoPlanoManejoAtoLegal (id, resumableFile, fileKey) {
      this.informacoesAtosLegais.anexoPlanoManejoAtoLegal = {
        nome: resumableFile.fileName,
        tipo: {
          id: 67,
          codigo: 'ATOS_CONSTITUTIVOS'
        },
        key: fileKey
      }
      this.$emit('update:atos', { ...this.informacoesAtosLegais })
    },
    onSuccessAnexoDocumentoConselho (id, resumableFile, fileKey) {
      this.informacoesAtosLegais.anexoDocumentoConselho = {
        nome: resumableFile.fileName,
        tipo: {
          id: 67,
          codigo: 'ATOS_CONSTITUTIVOS'
        },
        key: fileKey
      }
      this.$emit('update:atos', { ...this.informacoesAtosLegais })
    },
    onSuccessInstrumentosGestao (id, resumableFile, fileKey) {
      this.informacoesAtosLegais.anexoInstrumentoGestao = {
        nome: resumableFile.fileName,
        tipo: {
          id: 67,
          codigo: 'ATOS_CONSTITUTIVOS'
        },
        key: fileKey
      }
      this.$emit('update:atos', { ...this.informacoesAtosLegais })
    },
    onSuccessInstrumentosGestaoAtoLegal (id, resumableFile, fileKey) {
      this.informacoesAtosLegais.anexoInstrumentoGestaoAtoLegal = {
        nome: resumableFile.fileName,
        tipo: {
          id: 67,
          codigo: 'ATOS_CONSTITUTIVOS'
        },
        key: fileKey
      }
      this.$emit('update:atos', { ...this.informacoesAtosLegais })
    },
    removerAnexoAtoLegal () {
      this.informacoesAtosLegais.anexoAtoLegal = null
      this.$emit('update:atos', { ...this.informacoesAtosLegais })
    },
    removerAnexoPlanoManejo () {
      this.informacoesAtosLegais.anexoPlanoManejo = null
      this.$emit('update:atos', { ...this.informacoesAtosLegais })
    },
    removerAnexoPlanoManejoAtoLegal () {
      this.informacoesAtosLegais.anexoPlanoManejoAtoLegal = null
      this.$emit('update:atos', { ...this.informacoesAtosLegais })
    },
    removerAnexoDocumentoConselho () {
      this.informacoesAtosLegais.anexoDocumentoConselho = null
      this.$emit('update:atos', { ...this.informacoesAtosLegais })
    },

    removerInstrumentoGestao () {
      this.informacoesAtosLegais.anexoInstrumentoGestao = null
    },
    removerInstrumentoGestaoAtoLegal () {
      this.informacoesAtosLegais.anexoInstrumentoGestaoAtoLegal = null
    }
  },
  watch: {
    informacoesAtosLegais: {
      handler (newVal) {
        this.$emit('update:atos', newVal)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.erro {
  border-color: red;
}
.radio-group-horizontal .el-radio {
  display: inline-block;
  margin-top: 15px;
}
.radio-label {
  margin-bottom: 8px;
  margin-top: 10px;
}
.label-text {
  font-weight: bold;
}
.label-wrapper {
  margin-bottom: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.margin.mb-20 {
  margin-bottom: 25px;
}
.el-row {
  margin-bottom: 20px;
}

.el-col.inputDiv {
  margin-bottom: 20px;
}
.full-width {
  width: 95%;
}
.full-width-select {
  width: 90%;
}
.full-width-documento {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppFormularioAtosLegais.vue